module.exports = __webpack_public_path__ + "img/Navy Blue Chat Icon.47a6945a.svg";